(function (angular) {
	'use strict';

	angular
		.module('investmentGoalModule')
		.controller('InvestmentGoalSelect', [
			'$filter',
			'$scope',
			'APP_BASE_PATH',
			'Big',
			'INVESTMENT_GOAL_TIME_HORIZON_OPTIONS',
			'investmentGoalFactory',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'ROUNDING_VALUES',
			'urlFactory',
			InvestmentGoalSelectFunction
		]);

	function InvestmentGoalSelectFunction(
		$filter,
		$scope,
		APP_BASE_PATH,
		Big,
		INVESTMENT_GOAL_TIME_HORIZON_OPTIONS,
		investmentGoalFactory,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		ROUNDING_VALUES,
		urlFactory
	) {		
		var selectGoal = this;

		function setAmountandAmountOptions(initialLoad){
			investmentGoalFactory.getAmountOptionsForTimeHorizon(selectGoal.timeHorizon.value)
				.then(function(data) {
					selectGoal.amountOptions = data.amountOptions;
					
					if(initialLoad && angular.isDefined(selectGoal.currentInvestmentGoal)){
						var value = Number(new Big(selectGoal.currentInvestmentGoal.goalAmount));
						selectGoal.amountOptions[0] = {
							value: value,
							label: $filter('currency')(selectGoal.currentInvestmentGoal.goalAmount, '$', 0),
							sortIndex: value
						};
					}

					selectGoal.amount = selectGoal.amountOptions[0];
					selectGoal.minimumAmount = data.minimumAmount;
					selectGoal.maximumAmount = data.maximumAmount;
					updateChartData();
				})
				.catch(function(error){
					urlFactory.handleFailedRequest(error);
				});
		}

		selectGoal.deleteGoal = function(){
			mixpanelFactory.track('Investment Goal Deleted');

			investmentGoalFactory.deleteGoal()
				.then(function(){
					urlFactory.redirect('/investment-goal/delete-current-goal-success');
				})
				.catch(function(){
					urlFactory.redirect('/investment-goal/delete-current-goal-fail');
				});
		};
		
		selectGoal.changeTimeHorizon = function() {
			selectGoal.form.amount.$setUntouched();
			setAmountandAmountOptions();
			trackGoalUpdate('Time horizon changed');
		};

		selectGoal.submit = function(){
			selectGoal.formSubmitted = true;
			
			var mixpanelObj = {
				'Average Amount': selectGoal.roundedAverageAmount.toFixed(0),
				'Selected Goal Amount': selectGoal.amount.value,
				'Goal vs. Average': selectGoal.goalVsAvgStatus
			};
			
			mixpanelFactory.track('Investment Goal Selected', mixpanelObj);
			
			//Auto invest settings are hard-coded because we aren't using the projected amount series
			investmentGoalFactory.submitInvestmentGoal(
				selectGoal.goal,
				selectGoal.amount.value,
				selectGoal.timeHorizon.value,
				'AUTO_INVEST',
				100,
				'MONTHLY',
				true
			).then(function(){
				urlFactory.redirect('/investment-goal/invest');
			}, function(response){
				urlFactory.handleFailedRequest(response);
			});
		};

		function updateChartData(){
			//Auto invest settings are hard-coded because we aren't using the projected amount series
			investmentGoalFactory.getInvestmentGoalData(
				'NEW_GOAL_SELECT_GOAL',
				selectGoal.goal,
				selectGoal.amount.value,
				selectGoal.timeHorizon.value,
				100,
				'MONTHLY',
				true
			).then(function(response){
				var pointWhereGoalAchieved = $filter('filter')(response.chartData, { expectedGoalAchievedDate: true })[0];
				var indexWhereGoalAchieved = response.chartData.indexOf(pointWhereGoalAchieved);

				selectGoal.chartData = response.chartData.slice(0, indexWhereGoalAchieved + 1);

				getGoalVsAvgStatus();
			}, function(response){
				urlFactory.handleFailedRequest(response);
			});
		}

		function getGoalVsAvgStatus(){
			var lastPointIndex = selectGoal.chartData.length - 1;
			var roundedGoalAmount = $filter('roundToNearestValue')(selectGoal.chartData[lastPointIndex].goalAmount, selectGoal.roundingValue);
			selectGoal.roundedAverageAmount = $filter('roundToNearestValue')(selectGoal.chartData[lastPointIndex].averageInvestorAmount, selectGoal.roundingValue);
			
			if (roundedGoalAmount.eq(selectGoal.roundedAverageAmount)) {
				selectGoal.goalVsAvgStatus = 'in line with';
			} else if (roundedGoalAmount.gt(selectGoal.roundedAverageAmount)) {
				selectGoal.goalVsAvgStatus = 'more than';
			} else {
				selectGoal.goalVsAvgStatus = 'less than';
			}

			selectGoal.showAmountAlert = selectGoal.amount.value !== 0;
		}

		function trackGoalUpdate(event){
			mixpanelFactory.track('Investment Goal Changed', {
				'Event' : event,
				'Goal' : selectGoal.goal,
				'Goal Amount' : selectGoal.amount.value,
				'Time Horizon' : selectGoal.timeHorizon.value
			});
		}
		
		selectGoal.openConfirmationModal = function() {
			$scope.$broadcast('confirmationModal:open');
		};

		function getIneligibleMessage(data) {
			var url;

			if (!data.hasNonIraPlanSelection) {
				return 'Unfortunately, IRA accounts are not supported by investment goals at this time. ' +
					'We apologize for any inconvenience and will be sure to notify you if we add support in the future.';
			} else if (!data.hasDripEnabled) {
				url = APP_BASE_PATH + '/account/investment-accounts/' + INVESTMENT_ENTITY_ID + '/' + selectGoal.investmentEntityUrlPath + '/ria-dividend-reinvestment/manage';
				return 'You must <a href="' + url +'">enable dividend reinvestment</a> in order to create an investment goal.';
			} else if (!data.hasBalancedOrGrowthRiaPlanStrategy) {
				url = APP_BASE_PATH + '/account/investment-accounts/' + INVESTMENT_ENTITY_ID + '/' + selectGoal.investmentEntityUrlPath + '/investment-goal/manage';
				return 'Unfortunately, the investment goals feature is not currently supported for investors with a Supplemental Income plan. ' +
					'You can <a href="' + url + '">change&nbsp;your&nbsp;plan</a> from your account settings. ' +
					'We apologize for any inconvenience and will be sure to notify you if we add support in the future.';
			} else {
				url = APP_BASE_PATH + '/account/additional-investment/start';
				return 'You may only create an investment goal if you have current eREIT or eFund shareholdings. ' +
					'You can <a href="' + url + '">add&nbsp;funds</a> to your account to become eligible.';
			}
		}

		selectGoal.createNewGoal = function() {
			selectGoal.newGoal = true;
			selectGoal.timeHorizon = selectGoal.timeHorizonOptions[1];
			selectGoal.changeTimeHorizon();
		};

		function initialize(data) {
			selectGoal.loaded = true;
			selectGoal.eligibleForInvestmentGoal = data.eligibleForInvestmentGoal;
			selectGoal.currentInvestmentGoal = data.currentInvestmentGoal;
			selectGoal.title = angular.isDefined(selectGoal.currentInvestmentGoal) ? "Update investment goal" : "Create your investment goal";

			if (!selectGoal.eligibleForInvestmentGoal){
				selectGoal.ineligibleMessage = getIneligibleMessage(data);
			}

			if (angular.isDefined(selectGoal.currentInvestmentGoal)) {
				selectGoal.goal = selectGoal.currentInvestmentGoal.plan;
				selectGoal.timeHorizon={ value: selectGoal.currentInvestmentGoal.monthsRemaining };	
				selectGoal.endDate = selectGoal.currentInvestmentGoal.endDate;
			} else {
				selectGoal.newGoal = true;
				selectGoal.timeHorizon = selectGoal.timeHorizonOptions[1];
			}
			
			selectGoal.roundingValue = ROUNDING_VALUES.totalAccountValue;
			setAmountandAmountOptions(true);
		}

		selectGoal.$onInit = function() {
			angular.extend(selectGoal, globalConfig);
			selectGoal.timeHorizonOptions = INVESTMENT_GOAL_TIME_HORIZON_OPTIONS;
			investmentGoalFactory.getCurrentGoal()
				.then(function(response){ 
					initialize(response.data);
				});
		};

		$scope.$watch('selectGoal.amount', function () {
			if(angular.isDefined(selectGoal.amount) && angular.isDefined(selectGoal.amount.value) && selectGoal.amount.value !== 'other') {
				updateChartData();
			}
		});

	}
})(window.angular);